import { EffectsModal } from '../EffectsModal';

export const TotalDeathsModal = ({ title, event }) => EffectsModal({
  title,
  desc: `Whenever possible, total number of deaths from the ${event} and secondary effects are listed.`,
});
